module.exports = __webpack_public_path__ + "static/media/FT-FONDO-Chatbot.9fc8e175.jpg";